import React from "react";
import { useDrag } from "react-dnd";

const SidebarItem = ({ type, label }) => {
  const [{ isDragging }, drag] = useDrag({
    type: "field",
    item: { type },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  });

  return (
    <div ref={drag} className="sidebar-item" style={{ opacity: isDragging ? 0.5 : 1 }}>
      {label}
    </div>
  );
};

export default SidebarItem;
